import { Injectable } from '@angular/core';
import { ILogger } from '../common/core/logger';

@Injectable()
export class AppLogger implements ILogger {
  setSession(_sessionId: string) {}

  setPerson(_id?: string, _email?: string) {}

  setContext(_context: string) {}

  error(...args: any[]) {
    console.error.apply(console, args);
  }

  log(...args: any[]) {
    console.log.apply(console, args);
  }

  debug(...args: any[]) {
    console.debug.apply(console, args);
  }

  info(...args: any[]) {
    console.info.apply(console, args);
  }

  warn(...args: any[]) {
    console.warn.apply(console, args);
  }
}
